import React from "react";
import './Last.css';
import { WHATSAPP_AULA, INSTAGRAM, FACEBOOK, EMAIL } from '../../config';

const Last = () => {
    return (
        <>
            <section className="s_last">
                <h2>Estás pronto para começar?</h2>
                <p>Marca uma aula experimental em qualquer um dos nossos locais.</p>
                <a className="button_last" href={WHATSAPP_AULA} target="_blank" rel="noopener noreferrer">
                    Marca já a tua aula
                </a>
            </section>

            <section id="contact" className="contact-section">
                <h2 className="section-title">Contactos</h2>
                <p>Para mais informações, entra em contacto connosco:</p>

                <ul className="contact-icons">
                    <li><a href={WHATSAPP_AULA} target="_blank" rel="noopener noreferrer">WhatsApp</a></li>
                    <li><a href={INSTAGRAM} target="_blank" rel="noopener noreferrer">Instagram</a></li>
                    <li><a href={FACEBOOK} target="_blank" rel="noopener noreferrer">Facebook</a></li>
                    <li><a href={`mailto:${EMAIL}`}>E-mail</a></li>
                </ul>
            </section>
        </>
    );
}

export default Last;
